import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import styles from './Overlay.module.css';
import { useSelector } from 'react-redux';

const Overlay = () => {
  const location = useLocation();
  const currentLocation = location.pathname.split('/').pop();
  const shopTier = useSelector((state) => state.nonPersistedReducers?.shopTierSliceReducer?.shopTier);
  const shopId = useSelector((state) => state.nonPersistedReducers?.shopSliceReducer?.shopId);
  const navigate = useNavigate();
  const calculateOverlay = () => {
    return (
      (currentLocation === 'printing' && !shopTier?.printOption) ||
      (currentLocation === 'reports' && !shopTier?.reports) ||
      (currentLocation === 'invoicing' && !shopTier?.automaticInvoice)
    );
  };

  return (
    <div className={styles.container}>
      {calculateOverlay() && (
        <div className={styles.overlay}>
          <div className={styles.overlayText}>
            Ezt az oldalt a jelenlegi előfizetésed nem támogatja. Javasoljuk hogy válts nagyobb csomagra!
          </div>
          <button
            className={styles.button}
            onClick={() => navigate(`/shops/${shopId}/administration/subscriptions-bundles`)}>
            Megnézem az ajánlatokat
          </button>
        </div>
      )}
      <div className={styles.content}>
        <Outlet />
      </div>
    </div>
  );
};

export default Overlay;
